export const LEADS_VIEW = 'LEADS_VIEW';
export const LEADS_VIEW_LIST = 'LEADS_VIEW_LIST';
export const LEADS_VIEW_ANY_LIST = 'LEADS_VIEW_ANY_LIST';
export const LEADS_EDIT = 'LEADS_EDIT';
export const LEADS_CREATE = 'LEADS_CREATE';
